module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f3b8.e048d897.svg";